<template>
  <div class="cd_two-column-container">
    <div class="cd_container">
      <div class="cd_two-column">
        <div :class="col1_class">
          <slot name="col1_content"></slot>
        </div>
        <div :class="col2_class">
          <slot name="col2_content"></slot>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'TwoColumn',
    components: {
    },
    props: {
      col1_class: String,
      col2_class: String
    }
  }
</script>
